/** The inline confirmation a destructive row action opens, below the row (DEC-191). */
import { createElement, useState } from 'react'
import { ConfirmBox, type RowAction } from './ScanRow'

export function useConfirm() {
  const [asking, setAsking] = useState<RowAction | null>(null)
  return {
    asking,
    ask: setAsking,
    box: asking ? createElement(ConfirmBox, { action: asking, onDone: () => setAsking(null) }) : null,
  }
}
